import { Facebook, Link2, MessageCircle, Send, Share2 } from "lucide-react";
import { toast } from "sonner";
import { Reveal, Eyebrow } from "./Reveal";
import { Logo } from "./Logo";
import { Follow } from "./Follow";
import { SITE_URL } from "../../lib/api";

const TEXT = "Maître Wouffa — Retour d'affection & réussite professionnelle. 150€ uniquement après satisfaction.";

const shares = () => {
  const u = encodeURIComponent(SITE_URL);
  const t = encodeURIComponent(TEXT);
  return [
    ["WhatsApp", MessageCircle, `https://api.whatsapp.com/send?text=${t}%20${u}`, "share-whatsapp"],
    ["Facebook", Facebook, `https://www.facebook.com/sharer/sharer.php?u=${u}`, "share-facebook"],
    ["Telegram", Send, `https://t.me/share/url?url=${u}&text=${t}`, "share-telegram"],
    ["X", Share2, `https://twitter.com/intent/tweet?url=${u}&text=${t}`, "share-x"],
  ];
};

const copy = async () => {
  try {
    if (navigator.share) { await navigator.share({ title: "Maître Wouffa", text: TEXT, url: SITE_URL }); return; }
    await navigator.clipboard.writeText(SITE_URL);
    toast.success("Lien copié — collez-le sur Instagram, TikTok ou ailleurs.");
  } catch { /* partage annulé */ }
};

export const Share = () => (
  <section className="border-t border-amber-900/40 bg-[#12100e]" data-testid="share-section">
    <div className="mx-auto grid max-w-7xl gap-10 px-5 py-20 md:px-10 lg:grid-cols-12 lg:items-center">
      <div className="lg:col-span-6">
        <Reveal><Eyebrow>Partager</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <p className="mt-4 font-serif-it text-3xl italic leading-snug text-amber-100 md:text-4xl">
            Un proche a besoin du Maître ? Envoyez-lui ce site.
          </p>
        </Reveal>
      </div>
      <Reveal delay={0.2} className="lg:col-span-6">
        <div className="flex flex-wrap gap-3">
          {shares().map(([name, Icon, href, id]) => (
            <a key={id} href={href} target="_blank" rel="noopener noreferrer" data-testid={id}
              className="flex items-center gap-2 rounded-full border border-amber-700/50 px-5 py-3 text-sm font-semibold text-amber-100 transition-colors duration-300 hover:bg-amber-400 hover:text-stone-950">
              <Icon className="h-4 w-4" /> {name}
            </a>
          ))}
          <button onClick={copy} data-testid="share-copy-link"
            className="flex items-center gap-2 rounded-full bg-amber-400 px-5 py-3 text-sm font-bold text-stone-950 transition-transform duration-300 hover:scale-105">
            <Link2 className="h-4 w-4" /> Copier le lien
          </button>
        </div>
      </Reveal>
      <Reveal delay={0.3} className="lg:col-span-12">
        <Follow />
      </Reveal>
    </div>
  </section>
);

export const Footer = () => (
  <footer className="border-t border-amber-900/40 px-5 pb-32 pt-16 md:px-10" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 md:flex-row md:items-end md:justify-between">
      <div className="flex items-center gap-4">
        <Logo size={52} />
        <div>
          <p className="font-display text-xl text-amber-100">Maître Wouffa</p>
          <p className="text-sm text-stone-400">Confidentialité et discrétion absolue.</p>
        </div>
      </div>
      <p className="max-w-xl text-xs leading-relaxed text-stone-400" data-testid="legal-notice">
        Mention légale : les prestations de voyance et de pratiques spirituelles relèvent de croyances personnelles et
        ne remplacent pas l'avis d'un médecin, avocat ou autre professionnel. Réservé aux personnes majeures.
      </p>
    </div>
    <p className="mx-auto mt-10 max-w-7xl text-xs text-stone-500">&copy; 2026 Maître Wouffa · Tous droits réservés.</p>
  </footer>
);
